import {
    FaCalendarDays,
    FaSquareTwitter,
    FaBarsStaggered,
    FaRegBell,
    FaCartShopping,
    FaMoneyBillTrendUp,
    FaLocationDot,
    FaRankingStar,
    FaCheck 
} from 'react-icons/fa6';
import {
    FaPhoneAlt,
    FaFacebookSquare,
    FaGooglePlusSquare,
    FaLinkedin,
    FaRegUserCircle,
    FaRegUser,
    FaMailBulk,
    FaPhone,
    FaPlus,
    FaUser,
    FaUsers,
    FaCar,
    FaCalendarAlt,
    FaRegStar,
    FaRegComment,
    FaEye,
    FaPen,
    FaTrash,
    FaLock,
    FaPlusCircle,
    FaRegChartBar,
    FaMoneyBillWave,
    FaFileExport,
    FaRegCalendarAlt,
    FaBriefcase 
} from 'react-icons/fa';
import {
    MdOutlineArrowForwardIos,
    MdDashboard,
    MdHomeRepairService,
    MdManageAccounts,
    MdKeyboardDoubleArrowRight,
    MdArrowBackIos,
} from 'react-icons/md';
import {
    IoIosArrowUp,
    IoMdEye,
    IoMdEyeOff,
    IoMdRemove,
    IoIosArrowForward,
    IoIosArrowDown,
    IoMdLogOut,
    IoMdAddCircleOutline,
  
} from 'react-icons/io';
import { CiLocationOn } from 'react-icons/ci';
import { IoMailOutline, IoTicket, IoPricetag } from 'react-icons/io5';
import { HiMiniBars3CenterLeft, HiMiniBars3 } from 'react-icons/hi2';
import { AiOutlineSchedule } from 'react-icons/ai';

const icons = {
    FaCalendarDays,
    FaPhoneAlt,
    FaFacebookSquare,
    FaSquareTwitter,
    FaGooglePlusSquare,
    FaLinkedin,
    FaRegUserCircle,
    MdOutlineArrowForwardIos,
    IoIosArrowUp,
    CiLocationOn,
    IoMailOutline,
    FaRegUser,
    IoMdEye,
    IoMdEyeOff,
    FaMailBulk,
    FaPhone,
    FaPlus,
    IoMdRemove,
    FaBarsStaggered,
    FaRegBell,
    HiMiniBars3CenterLeft,
    HiMiniBars3,
    IoIosArrowForward,
    IoIosArrowDown,
    FaCartShopping,
    MdDashboard,
    FaUser,
    FaUsers,
    FaCar,
    FaCalendarAlt,
    MdHomeRepairService,
    IoTicket,
    FaMoneyBillTrendUp,
    MdManageAccounts,
    FaRegStar,
    FaRegComment,
    MdKeyboardDoubleArrowRight,
    FaEye,
    FaPen,
    FaTrash,
    FaLocationDot,
    IoMdLogOut,
    FaRankingStar,
    IoPricetag,
    FaLock,
    FaPlusCircle,
    IoMdAddCircleOutline,
    MdArrowBackIos,
    FaRegChartBar,
    AiOutlineSchedule,
    FaMoneyBillWave,
    FaFileExport,
    FaCheck,
    FaRegCalendarAlt,
    FaBriefcase
};

export default icons;
